import type { ProductComponentLink } from '@/shared/hooks/api/catalog'

export function countDistinctPartSuppliers(
  productComponents: ProductComponentLink[]
): number {
  const supplierIds = new Set<string>()
  for (const row of productComponents) {
    supplierIds.add(row.component.supplier.id)
  }
  return supplierIds.size
}
